import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useFormikContext } from 'formik'
import LiquidCheckbox from '@src/components/LiquidCheckbox'
import {
  SemiConfigFormValues,
  SemiConfigClone,
  useProductFromQueryParam,
  getProductBasedUniqueIdName,
} from '../../ProductsConfiguration'

const useStyles = makeStyles()((theme) => ({
  checkbox: {
    paddingLeft: theme.spacing(4),
  },
}))

interface SelectAllCheckboxProps {
  searchResults: SemiConfigClone[]
}
const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = ({
  searchResults,
}) => {
  const { classes } = useStyles()
  const formik = useFormikContext<SemiConfigFormValues>()
  const product = useProductFromQueryParam()
  const uniqueIdName = getProductBasedUniqueIdName(product)
  const handleSelectAllControls = () => {
    if (!uniqueIdName) return
    const filteredResult = searchResults.filter(
      (result) =>
        !formik.values.selectedClones.some(
          (clone) => clone[uniqueIdName] === result[uniqueIdName]
        )
    )
    let updatedList: SemiConfigClone[] = []
    if (filteredResult.length > 0) {
      updatedList = [...formik.values.selectedClones, ...filteredResult]
    } else {
      updatedList = formik.values.selectedClones.filter(
        (result) =>
          !searchResults.some(
            (clone) => clone[uniqueIdName] === result[uniqueIdName]
          )
      )
    }
    formik.setFieldValue('selectedClones', updatedList, false)
  }
  const checkForAllSelected =
    formik.values.selectedClones.length > 0 &&
    !searchResults.find(
      (result) =>
        !formik.values.selectedClones.some(
          (clone) => clone[uniqueIdName] === result[uniqueIdName]
        )
    )

  return (
    <div className={classes.checkbox}>
      <LiquidCheckbox
        onChange={handleSelectAllControls}
        checked={checkForAllSelected}
        disabled={searchResults.length <= 0}
      />
    </div>
  )
}
export default SelectAllCheckbox
